// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__UIZFk","content":"LayoutSettings_content__pwjJE"};